import { Absence, LeaveOfAbsence } from '../../../models'

export default function doesAbsenceHaveComments(item: Absence | LeaveOfAbsence): boolean {
    const { comments } = item
    const reason = item.type === 'leaveOfAbsences' ? item.reason : undefined

    return !! comments.length || !! reason
}
